import alertMessagesViewTemplate from "./AlertMessagesViewTemplate";

/**
 * Define alert-message component, by default on error
 *
 * @type {*|directive}
 */

const AlertMessagesDirective = function () {
    return {
        restrict: "E",
        transclude: "true",
        template: alertMessagesViewTemplate,
        scope: {
            type: "@" // alert or none
        }
    };
};

export default AlertMessagesDirective;
